import {
  HttpErrorResponse,
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  type HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { USER_PREFERENCE_KEY_PREFIX } from '@infra/auth/auth.storage.service';
import { type Observable } from 'rxjs/internal/Observable';
import { tap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        next: () => {
          // Do nothing.
        },
        error: error => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401 || error.status === 403) {
              this.clearSessionData();
              this.router.navigate(['/login']);
            }
          }
        },
      })
    );
  }

  // Removes everything the session stored, but keeps the user preferences.
  private clearSessionData(): void {
    const sessionKeys = Object.keys(localStorage).filter(key => !key.startsWith(USER_PREFERENCE_KEY_PREFIX));

    for (const sessionKey of sessionKeys) {
      localStorage.removeItem(sessionKey);
    }
  }
}
